import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Input from "../../Elements/Form/Input";
import Button from "../../Elements/Button";
import useToastNotify from "../../../hook/useToastNotify";
import {INewUserData} from "../../../contracts/data/user";


const InnerCreateUserForm = (props: FormikProps<INewUserData>) => {
    const {toastNotify} = useToastNotify()

    useEffect(() => {
        if (props.status.hasOwnProperty('result')) {
            toastNotify(props.status?.result?.status, props.status?.result?.message)
        }
    }, [props.status])

    return (
        <React.Fragment>
            <Form>
                <div className={"w-full"}>
                    <Input name={"mobile"} label={"شماره موبایل"} placeholder={"شماره موبایل..."} isRequired
                           meta={props.getFieldMeta('mobile')} defaultValue={props.values?.mobile}/>
                    <Input name={"first_name"} label={"نام کاربر"} placeholder={"نام کاربر..."} isRequired
                           meta={props.getFieldMeta('first_name')} defaultValue={props.values?.first_name}/>
                    <Input name={"last_name"} label={"نام خانوادگی کاربر"} placeholder={"نام خانوادگی کاربر..."} isRequired
                           meta={props.getFieldMeta('last_name')} defaultValue={props.values?.last_name}/>
                </div>
                <div className={"text-right"}>
                    <Button title={"ثبت کاربر جدید"} isLoading={props.isSubmitting}/>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default InnerCreateUserForm